import React, { useEffect, useState } from "react";
import { Download, Printer } from "lucide-react";
import { api } from "@/lib/api";
import { useMeta } from "@/hooks/useMeta";

const KEY = "somnio_planner_ticks";
const PRINT_CSS = "@media print { header, footer, nav, .no-print { display: none !important } body { background: #fff } }";

export default function ProposalPlanner() {
  const [sections, setSections] = useState<any[]>([]);
  const [ticks, setTicks] = useState<Record<string, boolean>>(() => { try { return JSON.parse(localStorage.getItem(KEY) || "{}"); } catch { return {}; } });
  useMeta("Proposal Planner | Somnio.Co", "Your private checklist for planning the perfect proposal.");
  useEffect(() => { api.get("/proposal-planner").then((r) => setSections(r.data)); }, []);
  const toggle = (id: string) => setTicks((t) => { const n = { ...t, [id]: !t[id] }; localStorage.setItem(KEY, JSON.stringify(n)); return n; });
  return (
    <div className="max-w-2xl mx-auto px-5 py-16 md:py-24" data-testid="proposal-planner">
      <style>{PRINT_CSS}</style>
      <p className="eyebrow text-[10px] text-[var(--c-primary)] text-center">Your Private Proposal Planner</p>
      <h1 className="font-display font-light text-4xl sm:text-5xl text-center mt-4">Every detail, for the perfect moment</h1>
      <p className="text-sm text-neutral-600 text-center mt-5">Tick things off as you go. Your progress is saved on this device only.</p>
      <div className="no-print flex justify-center gap-3 mt-8">
        <button onClick={() => window.print()} className="inline-flex items-center gap-2 bg-neutral-900 text-white px-6 py-3 eyebrow text-[10px]" data-testid="planner-print"><Printer size={13} />Print</button>
        <a href="/site-media/somnio-proposal-planner.pdf" download className="inline-flex items-center gap-2 border border-neutral-900 px-6 py-3 eyebrow text-[10px]" data-testid="planner-pdf"><Download size={13} />Download PDF</a>
      </div>
      {sections.map((s, si) => (
        <section key={s.title} className="mt-12" data-testid={`planner-section-${si}`}>
          <h2 className="eyebrow text-[11px] text-[var(--c-primary)] border-b border-neutral-200 pb-2">{s.title}</h2>
          <ul className="mt-4 space-y-3">
            {s.items.map((it: string, ii: number) => {
              const id = `${si}-${ii}`;
              return (
                <li key={id}><label className="flex items-start gap-3 cursor-pointer text-sm md:text-base">
                  <input type="checkbox" checked={!!ticks[id]} onChange={() => toggle(id)} className="mt-1 accent-[var(--c-fg)]" data-testid={`planner-item-${id}`} />
                  <span className={ticks[id] ? "line-through text-neutral-400" : ""}>{it}</span></label></li>
              );
            })}
          </ul>
        </section>
      ))}
    </div>
  );
}
